import { api } from './api';
import type { FilterRequest, ResourceMetricsResponse, OrganizationalAnalyticsResponse, BenchDetailsResponse } from '../types/api';

/** Request body for POST /analytics/resource */
interface ResourceMetricsRequest {
  business_units: string[];
  sub_business_units: string[];
  delivery_managers?: string[];
  squads?: string[];
  start_year?: number;
  start_month?: number;
  end_year?: number;
  end_month?: number;
  employee_status?: FilterRequest['employee_status'];
  employee_types?: string[];
  countries?: string[];
  locations?: string[];
  pillars?: string[];
  work_mode_profiles?: string[];
}

function mapFiltersToResourceRequest(filters: FilterRequest): ResourceMetricsRequest {
  const body: ResourceMetricsRequest = {
    business_units: filters.business_units ?? [],
    sub_business_units: filters.sub_bus ?? [],
    delivery_managers: filters.delivery_managers ?? [],
    squads: filters.squads ?? [],
    start_year: filters.start_year,
    start_month: filters.start_month,
    end_year: filters.end_year,
    end_month: filters.end_month,
    employee_status: filters.employee_status ?? 'ACTIVE',
    employee_types: filters.employee_types ?? [],
    countries: filters.countries ?? [],
    locations: filters.locations ?? [],
    pillars: filters.pillars ?? [],
    work_mode_profiles: filters.work_mode_profiles ?? [],
  };
  return body;
}

/**
 * Fetches resource metrics for utilization metric cards (POST /analytics/resource).
 */
export async function getResourceMetrics(filters: FilterRequest): Promise<ResourceMetricsResponse> {
  const body = mapFiltersToResourceRequest(filters);
  const response = await api.post<ResourceMetricsResponse>('/analytics/resource', body);
  return response.data;
}

/**
 * Fetches organizational analytics / BU ranking (POST /analytics/organization).
 */
export async function getOrgRanking(filters: FilterRequest): Promise<OrganizationalAnalyticsResponse> {
  const body = mapFiltersToResourceRequest(filters);
  const response = await api.post<OrganizationalAnalyticsResponse>('/analytics/organization', body);
  return response.data;
}

/**
 * Fetches bench details - same shape as resource_analytics.detailed_data (POST /analytics/bench-details).
 */
export async function getBenchDetails(filters: FilterRequest): Promise<BenchDetailsResponse> {
  const response = await api.post<BenchDetailsResponse>('/analytics/bench-details', filters);
  return response.data;
}
